<section class="parent-container">
  <div class="mx-auto max-w-7xl gap-2 p-5 md:px-8">
    <div class="container-top">
      <div class="container-title flex items-center sm:justify-between justify-center sm:flex-row flex-col gap-2">
        <h1>Network Status</h1>
        <div
          class="flex h-14 items-center justify-center rounded-full border border-gray-50/75 bg-white px-4 pb-0.5 pt-2 shadow-sm lg:ml-2"
        >
          <app-toggle
            [disabled]="loading() ?? false"
            [ngModel]="(showMockData$ | async) ?? false"
            (ngModelChange)="showMockData$.next($event)"
            [label]="
              (showMockData$ | async)
                ? 'Switch to Real Data'
                : 'Switch to Sample Data'
            "
            size="md"
            color="primary"
          >
          </app-toggle>
        </div>
      </div>
    </div>

    <div
      class="flex h-full flex-col gap-2 transition-all duration-300 ease-in-out md:flex-row"
    >
      <div class="w-full flex-[3]">
        <app-analytics-widget
          class="relative flex h-full overflow-hidden rounded-2xl border-2 border-white/50 bg-white p-0.5 shadow-md"
        >
          <app-leaflet-map
            class="h-full"
            [categories]="categories()"
            [markers]="markers()"
          />
          @if (loading()) {
            <div class="widget-element-loading">
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
          }
        </app-analytics-widget>
      </div>
      <div class="flex flex-[1] flex-col gap-2">
        <app-analytics-widget class="flex-1 rounded-2xl shadow-md">
          <app-ons-widget-summary />
        </app-analytics-widget>

        <ng-container *ngxPermissionsOnly="Permission.BILLING_READ">
          <app-analytics-widget class="flex-1 rounded-2xl shadow-md">
            <app-ons-widget-billing [navigateOnClick]="true" />
          </app-analytics-widget>
        </ng-container>
      </div>
    </div>

    <div class="flex h-full w-full flex-col gap-2 pt-4 md:flex-row">
      <ng-container *ngxPermissionsOnly="Permission.TICKETING_READ">
        <app-analytics-widget class="flex-1 rounded-2xl shadow-md">
          <app-ons-widget-tickets [navigateOnClick]="true" />
        </app-analytics-widget>
      </ng-container>

      <ng-container *ngxPermissionsOnly="Permission.ORDERS">
        <app-analytics-widget class="flex-1 rounded-2xl shadow-md">
          <app-ons-widget-orders [navigateOnClick]="true" />
        </app-analytics-widget>
      </ng-container>

      <ng-container *ngxPermissionsOnly="Permission.SERVICES">
        <app-analytics-widget class="flex-1 rounded-2xl shadow-md">
          <app-ons-widget-services [navigateOnClick]="true" />
        </app-analytics-widget>
      </ng-container>
    </div>

    <div class="w-full pt-4">
      <app-ons-widget-observations
        [isLoading]="iqObservationsLoadings()"
        [observations]="observations()"
      />
    </div>
  </div>
</section>

